import { render, staticRenderFns } from "./markdown_editor.vue?vue&type=template&id=49a8b6ce&vue3"
import script from "./markdown_editor.vue?vue&type=script&lang=js&vue3"
export * from "./markdown_editor.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports